import React from "react";
import SoftwareHomePage from "./SoftwareHomePage";
import TenantHomePage from "./TenantHomePage";
import { useAppSelector } from "../redux/store";
import AppCircularProgress from "../components/common/AppCircularProgress";

const HomePage: React.FC = () => {
  const { company, loadingCompany } = useAppSelector((state) => state.company);

  if (loadingCompany) {
    return <AppCircularProgress />;
  }

  return company ? <TenantHomePage /> : <SoftwareHomePage />;
};

export default HomePage;
